import {
    BASE_URL, 
    POST,  
    SERVICE_REQUEST,
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";
  
  export const addserviceRequest = async (payload) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${SERVICE_REQUEST}`;
    return fetch(resource, {
      method: POST,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };
  
  